import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ExchangeRates } from '@app/store/models';
import { Pricing } from '../models';

export const priceActions = createActionGroup({
    source: 'Price',
    events: {
        'Get Chain Price': props<{ id: string }>(),
        'Get Chain Price Success': props<{ payload: Pricing | null }>(),
        'Get Chain Price Error': props<{ code: number }>(),
        'Get Store Price': props<{ id: string }>(),
        'Get Store Price Success': props<{ payload: Pricing | null }>(),
        'Get Store Price Error': props<{ code: number }>(),
        'Get Exchange Rates': emptyProps(),
        'Get Exchange Rates Success': props<{ payload: ExchangeRates }>(),
        'Get Exchange Rates Error': props<{ code: number }>(),
        Clear: emptyProps(),
    },
});
